import React from 'react';
import cn from 'classnames';

import { withTheme } from 'providers/Theme.provider';

import CN from './DropdownSearch.module.scss';

const DropdownSearch = ({ stylistList, isOpen, isBrightMode, isDarkMode, isLightMode, ...extra }) => (
  <div
    data-bem="DropdownSearch"
    className={cn({
      [CN.container]: true,
      [CN.dark]: isDarkMode,
    })}
  >
    <input
      data-bem="DropdownSearch__input"
      className={cn({
        [CN.search]: true,
        [CN.isOpen]: isOpen,
      })}
      {...extra}
    />

    {isOpen && (
      <div data-bem="DropdownSearch__list" className={CN.dropdown}>
        <ul>{stylistList}</ul>
      </div>
    )}
  </div>
);

const DropdownSearchHoc = withTheme({ hasBright: false })(DropdownSearch);

export default DropdownSearchHoc;
